import {
    Model,
    ResponseFill,
    HttpIgnore,
    ValidationRequired,
    ValidationCNPJ,
    IResource,
} from 'simpli-web-sdk'
import moment from 'moment'
import * as Helper from '@/helpers'
import {ItrackCollection} from '@/helpers'
import {Region} from '@/enums/Region'
import {UF} from '@/enums/UF'
import {DeliveryAudit} from '@/enums/DeliveryAudit'

@HttpIgnore()
export default class DeliveryAuditRequest extends Model {
  readonly $name: string = 'DeliveryAuditRequest'

  idFilial = Helper.getIdFilial()
  allRegion = ItrackCollection.allRegion.prependNull('app.all')
  allAudit = ItrackCollection.allAudit.prependNull('app.all')

  get ufCollection() {
    return ItrackCollection.getUfCollection(this.region).prependNull('app.all')
  }

  @ResponseFill('from')
  fromDate: string | null = null

  toDate: string | null = null

  @ResponseFill()
  @ValidationRequired()
  region: Region | null = null

  @ResponseFill()
  @ValidationRequired()
  uf: UF | null = null

  @ResponseFill()
  cidade: string | null = null

  @ResponseFill()
  sigla: string | null = null

  @ResponseFill('auditoria')
  audit: DeliveryAudit | null = null

  @ResponseFill()
  @ValidationCNPJ()
  cnpjEmbarcadorTransportador: string | null = null

  @ResponseFill('documentoDestinatario')
  @ValidationCNPJ()
  documentoDestinatario: string | null = null

  @ResponseFill()
  get to() {
    // we should send the next day to the server, the prop endDate is used only to control what the user input
    return !this.toDate ? this.toDate : moment(this.toDate).add(1, 'day').format()
  }

  set to(val) {
    if (val) {
      // in the way back we need to subtract, so the params in the route dont mess up
      this.toDate = moment(val).subtract(1, 'day').format()
    }
  }

  get regionResource() {
    return this.allRegion.get(this.region)
  }
  set regionResource(val: IResource | null) {
    this.region = val && val.$id as Region || null
  }

  get ufResource() {
    return this.ufCollection.get(this.uf)
  }
  set ufResource(val: IResource | null) {
    this.uf = val && val.$id as UF || null
  }

  get auditResource() {
    return this.allAudit.get(this.audit)
  }
  set auditResource(val: IResource | null) {
    this.audit = val && val.$id as DeliveryAudit || null
  }
}
